export default __webpack_public_path__ + "media/images/mailer/icon_grade-90d3c1679a902c5096be990382c711e7.png";